module.exports = __webpack_public_path__ + "img/syukyaku-EC-websit-003.bf87a263.jpg";